import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { Check, ArrowRight, Loader2, Trophy } from "lucide-react";
import { api } from "@/lib/api";

export function PlansGrid() {
  const nav = useNavigate();
  const [plans, setPlans] = useState(null);

  useEffect(() => {
    api.get("/plans").then((r) => setPlans(r.data)).catch(() => setPlans([]));
  }, []);

  if (!plans) return <div className="flex justify-center py-10 text-amber-200/80"><Loader2 className="animate-spin" /></div>;

  return (
    <>
    <p className="sm:hidden mb-3 text-center text-[11px] text-slate-400" data-testid="plans-swipe-hint">Swipe to compare plans →</p>
    <div className="flex sm:grid gap-4 sm:gap-5 sm:grid-cols-2 lg:grid-cols-4 overflow-x-auto sm:overflow-visible snap-x snap-mandatory no-scrollbar -mx-4 px-4 sm:mx-0 sm:px-0 pb-2" data-testid="plans-grid">
      {plans.map((p, i) => {
        const popular = p.id === "monthly";
        return (
          <div key={p.id} data-testid={`plan-card-${p.id}`}
            className={`relative p-[1px] rounded-3xl min-w-[84%] sm:min-w-0 snap-center ${popular ? "bg-gradient-to-br from-amber-500/60 via-amber-200/20 to-purple-500/30" : "bg-white/10"}`}>
            <div className="rounded-3xl bg-[#0E132A] p-6 h-full flex flex-col">
              {popular && <span className="self-start rounded-full bg-amber-500/15 border border-amber-500/30 px-3 py-1 text-[10px] uppercase tracking-wider text-amber-200 mb-3">Most Popular</span>}
              <span className="text-xs uppercase tracking-[0.18em] text-amber-400/90">{p.name}</span>
              <div className="mt-3 flex items-end gap-1.5">
                <span className="font-serif text-4xl text-slate-50">₹{p.price}</span>
                <span className="text-slate-400 text-sm mb-1">/ {p.validity_months === 1 ? "month" : `${p.validity_months} mo`}</span>
              </div>
              <p className="mt-1 text-xs text-amber-200/80">Questions at ₹{p.per_question_price} each + GST</p>
              <ul className="mt-4 space-y-2 flex-1">
                {(p.benefits || []).filter((b) => !/lucky draw/i.test(b)).map((b) => (
                  <li key={b} className="flex items-start gap-2 text-xs text-slate-300">
                    <Check size={14} className="text-amber-300 mt-0.5 shrink-0" /> {b}
                  </li>
                ))}
              </ul>
              <LuckyDrawBadge double={p.validity_months >= 3} testId={`plan-luckydraw-${p.id}`} />
              <button data-testid={`plan-choose-${p.id}`} onClick={() => nav(`/subscribe?plan=${p.id}`)}
                className={`mt-5 rounded-full w-full py-2.5 text-sm flex items-center justify-center gap-2 ${popular ? "btn-gold" : "btn-ghost-gold"}`}>
                Choose <ArrowRight size={15} />
              </button>
            </div>
          </div>
        );
      })}
    </div>
    </>
  );
}

export function LuckyDrawBadge({ double, testId }) {
  return (
    <div data-testid={testId}
      className={`mt-4 rounded-xl border px-3 py-2.5 flex items-start gap-2.5 ${double ? "border-amber-400/50 bg-gradient-to-r from-amber-500/15 to-purple-500/10" : "border-amber-500/20 bg-amber-500/5"}`}>
      <Trophy size={16} className="text-amber-300 mt-0.5 shrink-0" />
      <div className="text-left">
        <p className="text-xs font-semibold text-amber-100">{double ? "DOUBLE chance in Lucky Draw" : "Lucky Draw entry included"}</p>
        <p className="text-[11px] text-slate-400 leading-snug">{double ? "2 entries in the 24-month subscriber draw" : "1 entry in the 24-month subscriber draw"}</p>
      </div>
    </div>
  );
}
